import { twMerge } from "tailwind-merge"

const BodyTiny: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <p className={twMerge("text-[1rem] font-bold leading-[150%]", className)} {...props} />
}

export default BodyTiny
